import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import { t } from "@/lib/strings";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-obsidian text-white px-3 py-2 font-data text-xs border-2 border-obsidian">
      <div className="uppercase tracking-widest text-neutral-400">{label}</div>
      <div className="text-base font-bold">{t("results.score")} <span dir="ltr">{payload[0].value}</span></div>
    </div>
  );
};

export const TrendChart = ({ trend = [] }) => {
  return (
    <div className="h-[220px] w-full" data-testid="trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={trend} margin={{ top: 10, right: 16, left: -18, bottom: 0 }}>
          <CartesianGrid stroke="rgba(10,10,10,0.06)" vertical={false} />
          <XAxis
            dataKey="month"
            tickLine={false}
            axisLine={{ stroke: "#0A0A0A" }}
            tick={{ fontSize: 10, fontFamily: "JetBrains Mono", fill: "#525252" }}
          />
          <YAxis
            domain={[0, 100]}
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 10, fontFamily: "JetBrains Mono", fill: "#525252" }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="score"
            stroke="#FF4500"
            strokeWidth={2.5}
            dot={{ fill: "#0A0A0A", r: 3, strokeWidth: 0 }}
            activeDot={{ r: 5, fill: "#FF4500" }}
            isAnimationActive
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendChart;
